module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/caret-left-1c3a4d2adea0e481bee270dfee923dab.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/caret-left.svg
// module id = /PXy
// module chunks = 24